import { HTMLAttributes, ReactNode } from 'react'
import { classNames, Mods } from '../../lib/classNames/classNames'
import { Container } from '../Container'
import cls from './PageSection.module.scss'

type Variant = 'default' | 'compact'

interface PageSectionProps extends Omit<HTMLAttributes<HTMLElement>, 'title'> {
    title?: ReactNode
    children: ReactNode
    variant?: Variant
    align?: 'center' | 'start'
    as?: 'section' | 'div'
}

export const PageSection = ({
    title,
    children,
    variant = 'default',
    align = 'center',
    className,
    as: Tag = 'section',
    ...rest
}: PageSectionProps) => {
    const mods: Mods = {
        [cls.compact]: variant === 'compact',
        [cls.center]: align === 'center'
    }

    return (
        <Tag
            className={classNames(cls.root, mods, [className])}
            {...rest}
        >
            <Container className={cls.inner}>
                {title != null && <h2 className={cls.title}>{title}</h2>}
                {children}
            </Container>
        </Tag>
    )
}
